import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik, Form, Field } from "formik";
import { Button, Message } from "semantic-ui-react";

import FormsInputPassword from "../../inputs/password/forms_inputs_password";
import { setupAdminPassword } from "../../../../actions";
import SetupPasswordSchema from "./validate";

class FormsSetupPassword extends Component {
  state = {
    success: false,
    error: false,
    errorMessage: "",
  };

  render() {
    const { token } = this.props;

    if (this.state.success) {
      return (
        <div>
          <Message positive>
            <Message.Header>Password set successfully</Message.Header>
            <p>
              Your password has been set up. You can now log in to your account.
            </p>
          </Message>
          <Button
            primary
            fluid
            onClick={() => {
              window.location.href = "/";
            }}>
            Go to Login
          </Button>
        </div>
      );
    }

    return (
      <Formik
        initialValues={{ password: "", confirmPassword: "" }}
        onSubmit={(values, actions) => {
          this.props.setupAdminPassword(
            { token, password: values.password },
            (status, error) => {
              if (error) {
                const errorMessage =
                  (error.response &&
                    error.response.data &&
                    error.response.data.errorMessage) ||
                  "Password setup failed. Please try again.";
                this.setState({
                  error: true,
                  errorMessage,
                });
                actions.setSubmitting(false);
              } else {
                this.setState({ success: true });
              }
            }
          );
        }}
        validationSchema={SetupPasswordSchema}
        validateOnBlur={false}
        validateOnChange={false}
        render={({ isSubmitting }) => (
          <Form>
            <Field
              name="password"
              component={FormsInputPassword}
              secondaryLabel="New Password"
            />
            &nbsp;
            <Field
              name="confirmPassword"
              component={FormsInputPassword}
              secondaryLabel="Confirm Password"
            />
            &nbsp;
            <Button
              type="submit"
              primary
              fluid
              loading={isSubmitting}
              disabled={isSubmitting}>
              Set Password
            </Button>
            {this.state.error && (
              <Message negative>{this.state.errorMessage}</Message>
            )}
          </Form>
        )}
      />
    );
  }
}

export default connect(null, {
  setupAdminPassword,
})(FormsSetupPassword);
